<template>
  <div v-if="swaggerObject">
    <el-form>
      <div class="api-row">
        <el-form-item
          :label="$t('pages.datasetDetail.apiEndpoint')"
          class="form-item"
        >
          <el-input :value="swaggerObject.datasetUrl" disabled />
        </el-form-item>
        <el-button
          class="copy-link"
          icon="el-icon-link"
          v-clipboard:copy="swaggerObject.datasetUrl"
          v-clipboard:success="onCopySuccess"
          v-clipboard:error="onCopyError"
          >{{ $t("pages.datasetDetail.copy") }}</el-button
        >
      </div>
      <div class="api-row">
        <el-form-item
          :label="$t('pages.datasetDetail.apiKey')"
          class="form-item"
        >
          <el-input :value="swaggerObject.apiKey" disabled />
        </el-form-item>
        <el-button
          class="copy-link"
          icon="el-icon-link"
          v-clipboard:copy="swaggerObject.apiKey"
          v-clipboard:success="onCopySuccess"
          v-clipboard:error="onCopyError"
          >{{ $t("pages.datasetDetail.copy") }}</el-button
        >
      </div>
      <el-button
        :router-link="localizedLink(swaggerObject.docsUrl)"
        type="primary"
        class="doc-link"
        >{{ $t("documentation") }}</el-button
      >
    </el-form>

    <Table :data="tableData" class="table" :labels="tableLabels" size="sm" />
  </div>
</template>

<script>
export default {
  props: {
    swaggerObject: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      tableLabels: [
        this.$t("pages.datasetDetail.table.name"),
        this.$t("pages.datasetDetail.table.description"),
        this.$t("pages.datasetDetail.table.type"),
        this.$t("pages.datasetDetail.table.example")
      ]
    };
  },
  computed: {
    tableData() {
      return this.swaggerObject.schema.map(item => ({
        name: item.name || "",
        description: item.description || "",
        type: item.type || "",
        example: item.example || ""
      }));
    }
  },
  methods: {
    onCopySuccess() {
      this.$message({
        type: "success",
        message: this.$t("common.flashMessages.copiedSuccess")
      });
    },
    onCopyError() {
      this.$message({
        type: "error",
        message: this.$t("common.flashMessages.copiedError")
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.api-row {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  @include media("<navbar-sm") {
    margin-bottom: rem(10);
    flex-wrap: wrap;
  }
}

.form-item {
  margin: 0 20px 0 0;
  width: 450px;
  max-width: 100%;
  @include media("<navbar-sm") {
    margin-right: 0;
    width: 100%;
  }
}

.copy-link {
  ::v-deep {
    .el-button {
      padding-left: 0;
      padding-right: 0;
      background: transparent !important;
      border: transparent !important;
      color: $--color-purple !important;
      @include media("<navbar-sm") {
        position: absolute;
        top: rem(3);
        right: 0;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.table {
  margin: 55px 0 80px;
}

.doc-link {
  margin-top: rem(20);
  @include media("<navbar-sm") {
    margin-top: rem(14);
  }
}
</style>
